document.addEventListener('DOMContentLoaded', function () {
  const word = document.querySelector('.ck9-rotating-word');

  if (!word) return;

  const words = [
    'WORKS',
    'PERFORMS',
    'PLAYS'
  ];

  let index = 0;

  setInterval(function () {
    word.classList.add('ck9-word-out');

    setTimeout(function () {
      index = (index + 1) % words.length;
      word.textContent = words[index];

      word.classList.remove('ck9-word-out');
    }, 300);

  }, 2500);
});